module.exports = __webpack_public_path__ + "static/media/male-infertility.4ad8b0c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/male-infertility.jpg
// module id = 256
// module chunks = 0